import { AmountItem } from "@components/ui-kit/AmountItem";
import { currency } from "@src/utils/formatters";
import { useInvoiceDetailStore } from "../../../store";

export const ItemsList = () => {
  const store = useInvoiceDetailStore();

  if (!store.invoice?.invoiceItems.length) return null;

  return (
    <div className="flex flex-col space-y-2 mb-8">
      {store.invoice.invoiceItems.map((i) => (
        <AmountItem key={i.id} description={i.description}>
          {store.invoice
            ? currency.formatByCurrency(
                i.amount_in_currency,
                store.invoice.currency,
              )
            : null}
        </AmountItem>
      ))}
    </div>
  );
};
